import {Component, Input} from '@angular/core';
import {EndUserModel} from '../../end-user/models/end-user.model';
import {DescriptionCardImageModel, DescriptionCardInfo} from '../../shared/card-view/description-card-info/description-card-info';
import {DescriptionCardInfoComponent} from '../../shared/card-view/description-card-info/description-card-info.component';
import {RouteLibraryService} from '../../route/route-library.service';
import {OrderModel} from '../../dashboard/monitoring/order.model';
import {TranslateService} from '@ngx-translate/core';
import {TimeagoFormatter} from 'ngx-timeago';
import {ImmutableListRepositoryService} from '../../../lib/gelios-field/immutable-list-repository.service';
import {MainLightboxService} from '../../layout/main-lightbox.service';
import {UnitImagesShort} from '../../dashboard/monitoring/unit';
import {HttpClient} from '@angular/common/http';
import {OrderPhotosLightboxService} from '../../layout/order-photos-lightbox/order-photos-lightbox.service';
import {timestampToTimeAgo} from '../../utility/timestamp-functions';
import {RouteLibraryEntities} from '../../route/route-library-entity';
import {formatNumberDecimals} from '../../utility/utility-functions';
import {UserLinkService} from '../../user/user-link.service';
import {AuthorizationService} from '../../authorization/authorization.service';

@Component({
  selector: 'app-unit-end-user-info',
  templateUrl: '../../shared/card-view/description-card-info/description-card-info.component.html',
  styleUrls: ['../../shared/card-view/description-card-info/description-card-info.component.scss']
})
export class UnitEndUserInfoComponent extends DescriptionCardInfoComponent {
  info: DescriptionCardInfo;
  @Input() activeOrder: OrderModel;
  @Input() imageSrc: DescriptionCardImageModel;
  imagesShort: Array<UnitImagesShort> = null;

  @Input() set model(model: EndUserModel) {
    this.info = {
      columnFirst: [
        {
          title: 'Name and Surname',
          iconName: 'ic_profile',
          value: () => {
            return model.first_name + ' ' + model.last_name;
          }
        },
        {
          title: 'Login',
          iconName: 'ic_phone',
          routerLink: this.routeLibrary.getRoute({
            entity: RouteLibraryEntities.END_USER,
            id: model.id, action: 'view'
          }),
          value: () => {
            return model.login;
          }
        },
        {
          title: 'Rate',
          iconName: 'ic_dollar',
          routerLink: this.getValidValue(this.activeOrder.end_user_price_plan_id)
            ? this.routeLibrary.getRoute({
              entity: RouteLibraryEntities.END_USER_PRICE_PLAN,
              id: this.activeOrder.end_user_price_plan_id, action: 'view'
            }) : null,
          value: () => {
            return this.getValidValue(this.activeOrder.end_user_price_plan_name);
          }
        },
        {
          title: 'Payment method',
          iconName: 'ic_wallet',
          value: () => {
            return this.paymentMethod(this.activeOrder.paymentMethods);
          }
        },
      ],
      columnSecond: [
        this.startTime(this.activeOrder.start_time),
        {
          title: 'Duration',
          iconName: 'iс_duration',
          value: () => {
            return timestampToTimeAgo(this.activeOrder.start_time, this.timeagoFormatter);
          }
        },
        {
          title: 'Mileage',
          iconName: 'ic_distance',
          value: () => {
            const result = this.orderTotalMileage > 0 ? this.orderTotalMileage.toFixed(2) : this.orderTotalMileage;
            return this.activeOrder.status !== 'booked'
              ? result + ' ' + this.translates.instant('km')
              : '';
          }
        },
        {
          title: 'Order cost',
          iconName: 'ic_cash',
          value: () => {
            const currencyCode = this.getValidValue(this.activeOrder.currency_code);
            return this.activeOrder.status !== 'booked'
              ? formatNumberDecimals(this.orderTotalPrice) + ' ' + currencyCode
              : '';
          }
        },
      ]
    };
  }


  get orderTotalMileage(): number {
    return this.activeOrder && this.activeOrder.endUserOrderIntervals ?
      this.activeOrder.endUserOrderIntervals.reduce(
        (a, i) => a + (i.mileage ? i.mileage : 0), 0) : 0;
  }

  get orderTotalPrice(): number {
    return this.activeOrder && this.activeOrder.endUserOrderIntervals ?
      this.activeOrder.endUserOrderIntervals.reduce(
        (a, i) => a + (i.total_price ? i.total_price : 0), 0) : 0;
  }

  constructor(
    protected routeLibrary: RouteLibraryService,
    protected translates: TranslateService,
    protected timeagoFormatter: TimeagoFormatter,
    protected immutableListRepositoryService: ImmutableListRepositoryService,
    protected mainLightboxService: MainLightboxService,
    protected http: HttpClient,
    protected orderPhotosLightboxService: OrderPhotosLightboxService,
    protected userLinkService: UserLinkService,
    protected authorizationService: AuthorizationService
  ) {
    super(
      immutableListRepositoryService,
      mainLightboxService,
      http,
      orderPhotosLightboxService,
      translates,
      routeLibrary,
      userLinkService,
      authorizationService
    );
  }
}
